export const ALL_ACTIVITY_LOGS = 'activityLog@all';
export const MY_ACTIVITY_LOGS = 'activityLog@my';

export default {
    [ALL_ACTIVITY_LOGS]: { url: 'activity-log/get/all' },
    [MY_ACTIVITY_LOGS]: { url: 'activity-log/get/my' }
};
